import { useCallback, useEffect, useState } from 'react';
import { usePluginConfig } from '../../contexts/pluginContext';
import PluginFrame from '../../utils/PluginFrame';

const GoogleAdBlock = ({
  adDivId,
  slotId,
  dimensions,
  targeting = {},
  fullWidth = true,
  customStyle,
  fallbackComponent,
}) => {
  const pluginConfig = usePluginConfig();
  const frameConfig = pluginConfig.frameConfig;
  const pluginFrame = new PluginFrame(frameConfig);
  const [adIsEmpty, setAdIsEmpty] = useState(false);

  const importGoogleAds = useCallback(() => {
    const script = document.createElement('script');
    script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    script.async = true;
    document.head.append(script);
  }, []);

  const safelyPushAndDisplaySlot = () => {
    // This is a workaround for some ad blockers that block the googletag object.
    try {
      pushAndDisplaySlot();
    } catch(e) {
      console.error(e);
    }
  };

  const pushAndDisplaySlot = () => {
    const element = pluginFrame.getElementById(adDivId);

    window.googletag = window.googletag || { cmd: [] };
    window.googletag.cmd.push(function () {
      window[`evvnt-gtag-slot-${slotId}`] = googletag.defineSlot(slotId, dimensions, adDivId).addService(googletag.pubads());

      if (Object.keys(targeting).length > 0) {
        Object.keys(targeting).forEach((key) => {
          window[`evvnt-gtag-slot-${slotId}`].setTargeting(key, targeting[key]);
        });
      }
      googletag.pubads().enableSingleRequest();
      googletag.pubads().collapseEmptyDivs(true);
      googletag.pubads().setCentering(true);
      googletag.enableServices();

      googletag.cmd.push(function () {
        googletag.display(element);

        if (googletag.pubads().isInitialLoadDisabled()) {
          googletag.pubads().refresh([window[`evvnt-gtag-slot-${slotId}`]]);
        }
      });
    });
  };

  const destroySlots = () => {
    window.googletag
      .pubads()
      .getSlots()
      .forEach(function (slot) {
        if (slot.getAdUnitPath() === slotId) {
          window.googletag.destroySlots([slot]);
        }
      });
  }

  useEffect(() => {
    if (!window.googletag) {
      importGoogleAds();
    }

    safelyPushAndDisplaySlot();

    // If the ad is empty after 5 seconds, we will render the fallback component.
    setTimeout(() => {
      const element = pluginFrame.getElementById(adDivId);
      if (fallbackComponent && (!element || element.style.display === 'none')) {
        setAdIsEmpty(true);
      }
    }, 4000);

    return () => {
      // We want to destroy the slot and its related data when unmounting this component.
      try {
        if (window.googletag){
          destroySlots();
        }
      } catch (e) {
        console.error(e);
      }
    };
  }, []);

  if (adIsEmpty && fallbackComponent) {
    return fallbackComponent;
  } else {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }} className={
        `${fullWidth ? 'w-full' :  ''}`}>
        <div id={adDivId} style={customStyle}></div>
      </div>
    );
  }
};

export default GoogleAdBlock;
